import React, { useState, useEffect } from "react";

const OVP = (props) => {
  const [flag, setFlag] = useState(false);

  useEffect(() => {
    setFlag(true);
  }, []);
  if (!flag) {
    return (
      <div>
        <div className="row">
          <div className="col-sm-6">
            <div className="form-group">
              <label>Api Key</label>
              <input
                type="text"
                name="cloudKey"
                className="form-control inside-form"
                placeholder="API Key ..."
                required
                autoComplete="off"
              />
            </div>
          </div>
          <div className="col-sm-6">
            {/* text input */}
            <div className="form-group">
              <label>Api Secret</label>
              <input
                type="text"
                name="cloudSecret"
                className="form-control inside-form"
                placeholder="API Secret"
                required
                autoComplete="off"
              />
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-sm-6">
            <div className="form-group">
              <label>Api Key V2</label>
              <input
                type="text"
                name="cloudKeyV2"
                className="form-control inside-form"
                placeholder="API Key V2 ..."
                required
                autoComplete="off"
              />
            </div>
          </div>
          <div className="col-sm-6">
            {/* text input */}
            <div className="form-group">
              <label>Api Secret V2</label>
              <input
                type="text"
                name="cloudSecretV2"
                className="form-control inside-form"
                placeholder="API Secret V2"
                required
                autoComplete="off"
              />
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-sm-6">
            <div className="form-group">
              <label>Main Account ID</label>
              <input
                type="text"
                name="mainAccountId"
                className="form-control inside-form"
                placeholder="Main Account"
                required
                autoComplete="off"
              />
            </div>
          </div>
          <div className="col-sm-6">
            <div className="form-group">
              <label>Main Player id</label>
              <input
                type="text"
                name="firstPlayer"
                className="form-control inside-form"
                placeholder="Main Player"
                required
                autoComplete="off"
              />
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-sm-6">
            <div className="form-group">
              <label>SDK Key</label>
              <input
                type="text"
                name="licenseKey"
                className="form-control inside-form"
                placeholder="SDK Key"
                required
                autoComplete="off"
              />
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className="row">
        <div className="col-sm-6">
          <div className="form-group">
            <span>Coming Soon on Version 1.05</span>
          </div>
        </div>
      </div>
    );
  }
};

export default OVP;
